import React from 'react';

import { Box, Card, H1, Link, Separator, Text } from '@betterment/samba-react';

import urlBuilder from '../../Shared/url-builder';

export const AdvisorResourcesCard: React.FC<{ isFourOhOneKOnly: boolean }> = ({ isFourOhOneKOnly }) => (
  <Card css={{ p: 'space.300' }}>
    <Card.Header>
      <H1 variant="title200" css={{ mb: 'space.300' }}>
        Advisor resources
      </H1>
    </Card.Header>
    <Separator />
    <Card.Content>
      {isFourOhOneKOnly ? (
        <>
          <Box css={{ my: 'space.200' }}>
            <Link href={urlBuilder.getPlanSponsorResourceCenter()} target="_blank" rel="noopener noreferrer">
              Plan sponsor resource center
            </Link>
            <Text as="p">Explore all of our resources to help you and your clients manage their 401(k) plans.</Text>
          </Box>
          <Separator />
          <Box css={{ mt: 'space.200' }}>
            <Link href={urlBuilder.getFourOhOneKGlossary()} target="_blank" rel="noopener noreferrer">
              401(k) glossary
            </Link>
            <Text as="p">Familiarize yourself with common 401(k) terminology.</Text>
          </Box>
        </>
      ) : (
        <>
          <Text as="p" css={{ py: 'space.300' }}>
            Access tutorials, client-facing materials, and methodology overviews to help you set up your account,
            onboard clients, leverage tax-smart tooling, and more.
          </Text>
          <Separator />
          <Box css={{ pt: 'space.300' }}>
            <Link href={urlBuilder.getAdvisorContentHub()} target="_blank" rel="noopener noreferrer">
              View resources
            </Link>
          </Box>
        </>
      )}
    </Card.Content>
  </Card>
);
